import { SxProps } from '@mui/material'

export default {
  container: {
    margin: '0 auto',
  },
  titleContainer: {
    marginBottom: 3,
    textAlign: 'center',
  },
  link: {
    display: 'contents',
  },
} satisfies SxProps
